import React from 'react';
import { Wrap, Line, Element } from './styles.js';
export function SeparateLineWrap(props) {
  return /*#__PURE__*/React.createElement(Wrap, Object.assign({
    id: props.name,
    className: props.className,
    style: props.style
  }, process.env.ENV_RAW ? null : props.uiEvents), /*#__PURE__*/React.createElement(Element, null), props.children);
}
export function SeparateLine(props) {
  return /*#__PURE__*/React.createElement(Line, Object.assign({
    id: props.name,
    className: props.className,
    style: props.style,
    layout: props.layout
  }, process.env.ENV_RAW ? null : props.uiEvents), props.children);
}
export function SeparateLineElement(props) {
  return /*#__PURE__*/React.createElement("div", props.uiEvents);
}